<template>
  <div class="ac2">
    <!-- 标题 -->
    <div class="ac2-title">
      <h2>{{ this.mtitle }}</h2>
      <!-- {{ msrc }} -->
    </div>

    <!-- 循环项 -->
    <div class="ac2-item" v-for="(item, index) in data" :key="index" @click="gopay(item.methods, item.id)">
      <!-- 左侧图片 -->
      <div class="item-img">
        <img :src="item.img" alt="" />
      </div>
      <!-- 右侧信息 -->
      <div class="item-info">
        <!-- 标题 -->
        <div class="item-title">
          {{ item.title }}
        </div>
        <!-- 简介 -->
        <div class="item-jj">
          {{ item.jj }}
        </div>
        <p v-if="item.pay">{{ item.pay }}</p>
        <!-- 时间 -->
        <div class="item-time">付费阅读：2元/篇</div>
      </div>
    </div>
    <modal title="请支付阅读" btnType="1" modalType="middle" :showModal="showModal" @submit="showModal = false"
      @cancel="showModal = false">
      <template v-slot:body>
        <img style="display: flex; justify-content: center; width:200px; margin: 0 auto;" src="/imgs/pay.png" />
        <h2>微信支付：2元/篇</h2>
      </template>
    </modal>
  </div>
</template>

<script>
import Modal from "./../components/Modal";
export default {
  name: "ac2",
  props: {
    // 获取父组件传的请求路径
    msrc: String,
    // 获取父组件传的标题
    mtitle: String,
  },
  components: {
    Modal,
  },
  data() {
    return {
      data: [],
      // 获取到 user 用户信息
      nv_user: JSON.parse(window.localStorage.getItem("user")),
      // 存储状态
      state: JSON.parse(window.localStorage.getItem("state")),
      showModal: false,
    };
  },
  mounted() {
    this.init();
    document.title = "北京学灯教育科技有限公司";
  },
  methods: {
    init() {
      this.axios.get(this.msrc).then((res) => {
        const data = res.data;
        this.data = data.splice(0, 10);
      });
    },
    // 跳转 逻辑 封装
    goDays(methods, id) {
      this[methods](id);
    },
    // 收费逻辑
    gopay() {
      this.showModal = true;
      // if (this.state == 0) {
      //   this.$router.push({ path: "/pay", query: { k: 1 } });
      //   // this.showModal = true;
      // }
      // // 未登录
      // if (this.state !== 0) {
      //   alert("请登录付费2元后可浏览！！！~");
      //   this.$router.push({ path: "/login", query: { k: 1 } });
      //   return;
      // }
      // alert("此文章收费三元人民币，您的账户余额为0元");
      // this.$message.error("此文章收费三元人民币，您的账户余额为0元");
    },
    // 跳转详情页
    goDetails(id) {
      this.$router.push({
        path: "/sound/:" + id,
        query: { type: id },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";

.ac2 {
  width: 100%;

  //   height: 400px;
  // background-color: pink;
  // 标题
  .ac2-title {
    width: 100%;
    height: 40px;
    border-bottom: 1px solid #ccc;
    // padding-left: 30px;
    box-sizing: border-box;

    h2 {
      font-size: 16px;
      width: 80px;
      height: 100%;
      line-height: 40px;
      text-align: center;
      border-bottom: 1px solid $colorZ;
    }
  }

  // 循环线
  .ac2-item {
    width: 100%;
    height: 180px;
    // background-color: #c60023;
    margin: 10px auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;

    // 左侧图片
    .item-img {
      width: 300px;
      height: 100%;
      margin-right: 20px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    // 右侧信息
    .item-info {
      //   width: 70%;
      width: 400px;
      //   background-color: #ff6600;
      padding: 15px;
      box-sizing: border-box;

      //   height: 100%;
      //   标题
      .item-title {
        font-size: 18px;
        color: #121212;
        cursor: pointer;

        &:hover {
          color: $colorZ;
        }
      }

      // 简介
      .item-jj {
        width: 100%;
        height: 45px;
        font-size: 14px;
        color: #555;
        margin: 18px auto;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      //   时间
      .item-time {
        font-size: 12px;
        color: #888;
      }
    }
  }
}
</style>
